import { useCallback, useState } from "react";

export const useControllableState = <T>(
  defaultValue: T,
  value?: T,
  onChange?: (value: T) => void
): [T, (v: T) => void] => {
  const [state, setState] = useState(defaultValue);

  const handleChange = useCallback(
    (newState: T) => {
      if (value === undefined) {
        setState(newState);
      }
      if (onChange) {
        onChange(newState);
      }
    },
    [value, onChange]
  );

  return [value ?? state, handleChange];
};
